import * as React from 'react';
import List from 'components/AssetList';
import Header from 'components/AssetList/Header';
import { useToggle } from 'components/AssetList/hooks';
import StoryCard from 'components/AssetsCollection';
import { EntityType } from 'const';
import { MagicFormMap, StoryCardMap } from 'models';
import { intlGet } from 'utils/intlGet';
import { IStoryCardListProps } from './models';
import styles from './styles.module.scss';

const StoryCardList: React.FunctionComponent<IStoryCardListProps> = (props) => {
  const {
    items,
    showUpdatedStoryCards,
    toggleUpdatedDocumentsDisplaying,
    updatedInPromoMats,
    dataTestId = 'storyCardList',
  } = props;

  const {
    expanded,
    toggle,
  } = useToggle({
    toggleUpdatedDocumentsDisplaying,
    showUpdatedDocuments: showUpdatedStoryCards,
    entityType: EntityType.STORY_CARD,
  });
  const hasItems = items && items.size > 0;

  if (!hasItems) {
    return null;
  }

  return (
    <div className={styles.StoryCardList} data-title="story-cards" data-testid={dataTestId}>
      <Header
        title={intlGet('Assets', 'StoryCards', { count: items.size })}
        showUpdatesHint={updatedInPromoMats && showUpdatedStoryCards}
        expanded={expanded}
        onClick={toggle}
        dataTestId={`${dataTestId}-header`}
      />
      {
        expanded &&
        <List
          elements={items}
          renderElement={(storyCard: MagicFormMap | StoryCardMap, index: number): React.ReactNode => (
            <StoryCard key={storyCard.get('id')} document={storyCard} dataTestId={`${dataTestId}-list-item${index}`} />
          )}
          dataTestId={`${dataTestId}-list`}
        />
      }
    </div>
  );
};

export default StoryCardList;
